import React, { Fragment } from 'react';
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/system';

const SubMenuContainer = styled(Fragment)(({ theme }) => ({
  listItem: {
  },
  listItemText: {
    paddingLeft: 0,
    fontSize: '1.5rem',
  },
  sidebarIsOpen: {
    paddingLeft: 25,
    transition: `padding-left 195ms ${theme.transitions.easing.easeInOut} 0ms`,
  },
  sidebarIsClosed: {
    paddingLeft: 0,
    transition: `padding-left 195ms ${theme.transitions.easing.easeInOut} 0ms`,
  },
}));

const SubMenu = ({
  handleToggle,
  sidebarIsOpen,
  isOpen,
  name,
  icon,
  children,
  link,
}) => (
  <SubMenuContainer>
    <ListItem dense button onClick={handleToggle} className={sidebarIsOpen ? 'sidebarIsOpen' : 'sidebarIsClosed'}>
      <ListItemIcon sx={{minWidth: 40}}>{isOpen ? <ExpandMore /> : icon}</ListItemIcon>
      <ListItemText sx={{paddingLeft: 0}}
        inset
        primary={isOpen ? name : ''}
        secondary={isOpen ? '' : name}
      />
    </ListItem>
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <List dense component="div" disablePadding className={sidebarIsOpen ? 'sidebarIsOpen' : 'sidebarIsClosed'}>
        {children}
      </List>
    </Collapse>
  </SubMenuContainer>
);

export default SubMenu;
